<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
      indexData: {}
    };
  },
  data() {
    return {
      isRouterAlive: true,
      title: '',
      description: '',
      keywords: ''
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  async mounted() {
    //  let {index_seo}= await this.$fetch("Index/indexdata");
    //  this.keywords=index_seo.web_site_keyword;
    //  alert(this.keywords)
    //  this.description=index_seo.web_site_description;
    //  this.title=index_seo.web_site_title
    //  console.log(document.querySelector('meta[name="keywords"]'))
    //  document.querySelector('meta[name="keywords"]').setAttribute('content', this.indexData.index_seo.web_site_keyword)
    //  document.querySelector('meta[name="description"]').setAttribute('content', 接口获取的description)
  }
};
</script>

<style lang="scss">
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
}

/* 统一老式浏览器HTML5显示 */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1.2;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
img {
  border: none;
  vertical-align: top;
} /* 清除a标签中图片边框 */
input,
button,
textarea {
  vertical-align: middle;
  font: inherit;
  font-family: inherit;
  display: inline-block;
}
button,
label,
body a {
  cursor: pointer;
}
button {
  font-family: "Microsoft YaHei";
}
.textleft {
  text-align: left;
}

/* H1 - H6 */
h1 {
  margin-top: 8px;
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 36px;
}
h2 {
  margin-top: 8px;
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 30px;
}
h3 {
  margin-top: 8px;
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 25px;
}
h4 {
  margin-top: 8px;
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 20px;
}
h5 {
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 15px;
}
h6 {
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 11px;
}
.flex {
  display: flex;
  align-items: center;
}
.ju-be {
  justify-content: space-between;
}
.ju-ar {
  justify-content: space-around;
}
.ai-sr {
  align-items: flex-start;
}
/* 列表 */
ul {
  margin-left: 25px;
}
ul li {
  list-style: disc;
}
ul li ul li {
  list-style: none;
  margin-left: 5px;
}
ol {
  margin-left: 25px;
}
ol li {
  list-style-type: decimal;
}
ol li ol li {
  list-style-type: lower-alpha;
  margin-left: 5px;
}
dl dt {
  font-weight: bold;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

// table { border: 1px solid #DDD;}
td {
  padding: 5px;
}

p {
  margin: 15px 0;
}
hr {
  width: 100%;
  border: none;
  border-bottom: 1px solid #ccc;
  margin-top: 12px;
  margin-bottom: 12px;
}

:focus {
  outline: 0;
} /*清除链接虚线边框*/
.pad10 {
  padding: 10px;
}

/*主色*/
$primary-color: #f19d15;
/*配色*/
$ornament-color: #333;
/*红色*/
$danger-color: #f62b2b;
/*绿色*/
$success-color: #5cb85c;
/*一般*/
$info-color: #5bc0de;
/*黄色*/
$warning-color: #fa0;
/*灰色*/
$grey-color: #999;
/*网页背景色*/
$bg-color: #f5f5f5;

/*文字默认颜色*/
$font-color: #333;
/*链接文字颜色*/
$a-color: #333;
/*主要内容区域宽度*/
$wrap-width: 1200px;

/*=============铵钮=============*/

//默认颜色
$btn-default: #fff;
//主要颜色
$btn-primary: $primary-color;
//次要颜色
$btn-ornament: $ornament-color;
//红色
$btn-danger: $danger-color;
//绿色
$btn-success: $success-color;
//一般
$btn-info: $info-color;
//黄色
$btn-warning: $warning-color;
//灰色
$btn-grey: $grey-color;

@mixin clearfix {
  &:after {
    content: " ";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}
@mixin ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@mixin ellipsis-2 {
  overflow: hidden;

  text-overflow: ellipsis;

  display: -webkit-box;

  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
}
@mixin ellipsis-n($n) {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  box-orient: vertical;
  -webkit-line-clamp: $n;
}

@mixin btn($bgcolor, $bordercolor, $fontcolor) {
  &,
  &:visited {
    background-color: $bgcolor;
    border-color: $bgcolor;
    color: $fontcolor;
    &:hover {
      background-color: darken($bgcolor, 5%);
      border-color: darken($bgcolor, 8%);
      color: $fontcolor;
    }
    &:active {
      background-color: darken($bgcolor, 8%);
      border-color: darken($bgcolor, 10%);
    }
    &.btn-border {
      color: $bgcolor;
      &:hover {
        color: $fontcolor;
      }
    }
  }
}

@mixin img($w, $h) {
  display: block;
  position: relative;
  &:after {
    display: block;
    padding-top: $h/$w * 100%;
    content: "";
  }
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.dgzhbox {
  max-width: 300px;
  margin-left: 50px;
  padding: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.toastAmount {
  position: absolute;
  top: 60px;
  left: 330px;
}
.needspot {
  list-style: none;
  height: 24px;
  font-weight: 550;
  .dian {
    min-width: 8px;
    height: 8px;
    border-radius: 50%;
    background: $primary-color;
    margin-right: 6px;
  }
}
.couponModal {
  max-height: 92vh;
  overflow-y: auto;
}
body {
  min-width: $wrap-width;
  background: $bg-color;
  border: none;
  font-family: Verdana, Arial, "Microsoft YaHei";
  *font-family: "Microsoft YaHei";
  font-size: 14px;
  line-height: 1.6;
  color: $font-color;
}
.container {
  width: $wrap-width;
  margin: 0 auto;
  @include clearfix;
}

.clearlist {
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

a {
  text-decoration: none;
  color: inherit;
  &:hover {
    color: $primary-color;
  }
}
img {
  max-width: 100%;
  vertical-align: middle;
}
.primary_bg {
  background: $primary-color;
}
.bold {
  font-weight: bold;
}
.font-normal {
  font-weight: normal;
}
.fenye {
  margin: 20px auto;
  text-align: center;
}
.primary_bor {
  border-color: $primary-color;
}
/*常用*/
.color-primary {
  color: $primary-color;
}
.color-ornament {
  color: $ornament-color;
}
.color-red {
  color: #f62b2b;
}

.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.height100 {
  height: 100%;
}
.show {
  display: block;
}
.hide {
  display: none;
}
.clear {
  clear: both;
}
.clearfix {
  @include clearfix;
}
.ellipsis {
  @include ellipsis;
}
.ellipsis-2 {
  @include ellipsis-2;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.img1-1 {
  @include img(1, 1);
}
.img4-3 {
  @include img(4, 3);
}
.mt20 {
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px !important;
}
.mb20 {
  margin-bottom: 20px;
}
button {
  border: none;
  outline: none;
}
.text-right{
  text-align: right;
}
.text-center{
  text-align: center;
}
button[type="primary"] {
  background: $primary-color;
  color: #fff;
}

.text_l {
  text-align: left;
}

.nav_bar {
  width: 40px;
  background: #fff;
  overflow: hidden;
  position: fixed;
  left: 200px;
  top: 40%;
  z-index: 999;
  .item {
    padding: 0 4px;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    background: rgba(177, 170, 170, 1);
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 1px;
    color: #ffffff;
  }
  .active {
    background: $primary-color;
    color: #fff;
  }
}
.marginleft20 {
  margin-left: 20px;
}
.kuaijiemenu {
  width: 50px;
  overflow: hidden;
  position: fixed;
  line-height: 12px;
  right: 0px;
  top: 40%;
  z-index: 999;
  a {
    font-size: 14px;
    color: #fefefe;
    display: inline-block;
    line-height: 14px;
    text-align: center;
    height: 50px;
    // padding:  0 15px;
    width: 100%;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
    margin-bottom: 10px;
    .icon-lianxi {
      font-size: 28px;
      line-height: 28px;
    }
    .icon-cart {
      font-size: 28px;
    }
    .icon-edit {
      font-size: 28px;
    }
    .icon-up {
      font-size: 28px;
    }
    li {
      height: 100%;
      line-height: 14px;
    }
  }
  .active {
    height: 77px;
    background: rgba(241, 157, 21, 1);
    opacity: 0.8;
    position: relative;

    .center {
      flex-direction: column;
    }
  }
  .car {
    position: relative;
    .icon-cart {
      margin-top: 10px;
    }
    .carnum {
      position: absolute;
      background: red;
      color: #fff;
      padding: 1px 5px;
      border-radius: 10px;
      top: 0;
      right: 0px;
      font-size: 5px;
    }
  }
}
.yijianbox {
  width: 600px;
}
.pagination {
  margin: 50px 0;
  font-size: 0;
  text-align: center;
  li {
    display: inline-block;
  }
  a,
  span {
    display: inline-block;
    margin: 0 4px;
    padding: 0 15px;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    background-color: #eee;
    font-size: 14px;
    &:hover {
      color: $primary-color;
    }
  }
  li.active a,
  li.active span {
    background-color: $primary-color;
    border-color: $primary-color;
    color: #fff;
  }
  li.disabled a,
  li.disabled span {
    background-color: #eee;
    color: #bbb;
  }
}
.img {
  overflow: hidden;
}
.hoverimg {
  cursor: pointer;
  transition: all 0.5s;
}
.hoverimg:hover {
  transform: scale(1.2);
}
.color-000 {
  color: #000;
}
.numberbox {
  display: inline-block;
  vertical-align: middle;
  height: 30px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  background-color: #fff;
  position: relative;
  line-height: 28px;
  font-size: 0;
  overflow: hidden;

  .btn {
    height: 28px;
    width: 30px;
    padding: 0;
    background: none;
    border-radius: 0;
    -webkit-appearance: none;
    display: inline-block;
    vertical-align: middle;
    border: none;
    font-size: 12px;
    text-align: center;
    &:active {
      background-color: #f8f8f8;
    }
    &:disabled {
      color: #ccc;
    }
  }

  input {
    width: 40px;
    height: 28px;
    border: none;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    box-sizing: border-box;
    vertical-align: middle;
    -webkit-appearance: none;
    background: none;
    border-radius: 0;
    font-size: 14px;
    text-align: center;
    position: relative;
    z-index: 2;
  }
}

.star {
  display: inline-block;
  vertical-align: middle;
  margin-top: -3px;
  position: relative;
  line-height: 1;
  color: #faab20;
  letter-spacing: 0.2em;
  font-size: 12px;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &:before {
    content: "\e61b\e61b\e61b\e61b\e61b";
    color: #e6e6e6;
  }
  &:after {
    content: "\e61b\e61b\e61b\e61b\e61b";
    width: 0;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
  }
  &.star01:after {
    width: 20%;
  }
  &.star02:after {
    width: 40%;
  }
  &.star03:after {
    width: 60%;
  }
  &.star04:after {
    width: 80%;
  }
  &.star05:after {
    width: 100%;
  }
}
.pjstar {
  height: 20px;
  font-size: 20px;
  color: #e6e6e6;
  display: inline-block;
}
.pjstar .iconfont {
  margin-right: 10px;
  width: 20px;
  cursor: pointer;
}
.pjstar.star01 .iconfont:nth-child(1) {
  color: #faab20;
}
.pjstar.star02 .iconfont:nth-child(1),
.pjstar.star02 .iconfont:nth-child(2) {
  color: #faab20;
}
.pjstar.star03 .iconfont:nth-child(1),
.pjstar.star03 .iconfont:nth-child(2),
.pjstar.star03 .iconfont:nth-child(3) {
  color: #faab20;
}
.pjstar.star04 .iconfont:nth-child(1),
.pjstar.star04 .iconfont:nth-child(2),
.pjstar.star04 .iconfont:nth-child(3),
.pjstar.star04 .iconfont:nth-child(4) {
  color: #faab20;
}
.pjstar.star05 {
  color: #faab20;
}

// .mask {
//   display: none;
//   background-color: #000;
//   opacity: 0.5;
//   filter: alpha(opacity=50);
//   position: fixed;
//   left: 0;
//   right: 0;
//   top: 0;
//   bottom: 0;
//   z-index: 10;
// }

.layui-form-checkbox[lay-skin="primary"] {
  padding-left: 20px;
  span {
    padding-right: 10px;
  }
}

.top {
  height: 30px;
  background-color: #f2f2f2;
  line-height: 30px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  .top-r {
    a {
      margin: 0 10px;
      color: #999;
    }
  }
}
.header {
  height: 110px;
  background-color: #fff;
  // block-size: border-box;
  box-sizing: border-box;
  padding-top: 15px;
  // margin-top: 12px;
  .logo {
    float: left;
    height: 50px;
    // line-height: 110px;
    img {
      vertical-align: middle;
      width: 151px;
      height: 50px;
    }
  }
  .search {
    float: left;
    margin: 0px 0 0 120px;
    form {
      height: 40px;
    }
    input {
      width: 500px;
      height: 40px;
      padding: 0 15px;
      float: left;
      background-color: #fff;
      border: 1px solid $primary-color;
      box-sizing: border-box;
    }
    button {
      width: 50px;
      height: 40px;
      background: $primary-color;
      border: none;
      color: #fff;
      font-size: 16px;
    }
    .hotwords {
      margin-top: 10px;
      font-size: 12px;
      a {
        margin-right: 10px;
        color: #999;
        font-size: 12px;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
  .mallcart {
    width: 200px;
    height: 40px;
    display: block;
    position: relative;
    float: right;
    // margin-top: 35px;
    background-color: #fff;
    border: 1px solid #eee;
    text-align: center;
    line-height: 38px;
    color: $primary-color;
    box-sizing: border-box;
    .icon-cart {
      font-size: 18px;
      vertical-align: middle;
    }
    .cart-count {
      display: inline-block;
      padding: 0 4px;
      background-color: $primary-color;
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      border-radius: 8px;
      vertical-align: middle;
    }
  }
}

.nav {
  min-width: $wrap-width;
  height: 40px;
  background-color: #fff;
  border-bottom: 2px solid $primary-color;
  .nav-service {
    position: relative;
    width: 200px;
    height: 40px;
    float: left;
    background-color: $primary-color;
    position: relative;
    z-index: 4;
    .tit {
      height: 40px;
      padding-left: 25px;
      color: #fff;
      font-size: 16px;
      line-height: 40px;
      .icon-menu {
        font-size: 18px;
      }
    }
    .downmenu {
      width: 100%;
      height: 452px;
      background-color: rgba(#333, 0.8);
      position: absolute;
      left: 0;
      top: 100%;
      color: #fff;
      .item {
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
        height: 40px;
        border-bottom: 1px solid #524a2c;
        box-sizing: border-box;

        .hd {
          font-size: 14px;
          background: no-repeat left center;
          height: 20px;
          line-height: 20px;
          a:hover {
            color: #fff;
          }
          a {
            color: #fff;
          }
        }
        .cont {
          font-size: 12px;
          margin-top: 5px;
          a {
            color: #ccc;
            margin-right: 10px;
            display: inline-block;
            &:hover {
              color: #fff;
            }
          }
        }
      }
      .item:hover .sonclassfy {
        display: block;
      }
      .item:hover {
        background: $primary-color;
      }
    }
  }
  .nav-main {
    float: left;
    margin-left: 30px;
    font-size: 15px;
    font-weight: bold;
    line-height: 40px;
    li {
      float: left;
    }
    a {
      display: block;
      padding: 0 30px;
      &.active {
        color: $primary-color;
      }
    }
  }
}
.sonAccount {
  padding: 30px;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    margin-bottom: 30px;
  }
}
.sonclassfy {
  .ai-sa {
    align-items: flex-start;
  }
  padding: 15px;
  box-sizing: border-box;
  position: absolute;
  z-index: 999;
  background: #fff;
  width: 780px;
  display: none;
  top: 2px;
  left: 200px;
  // min-height: 450px;
  height: 450px;
  overflow-y: auto;
  .sonclassfy_item {
    align-items: flex-start;

    width: 500px;
    .title_icon {
      width: 88px;
      font-size: 12px;
      overflow: hidden;
      color: #333;
      line-height: 12px;
      border-bottom: 1px #f5f5f5 dashed;
      height: 40px;
      a {
        font-weight: bold;
        line-height: 14px;
        font-size: 12px;
      }
    }
    .classfy3 {
      width: 400px;
      margin-top: 5px;
      margin-left: 20px;
      a {
        color: #999;
        padding-right: 5px;
        margin-right: 8px;
        line-height: 16px;
      }
    }
    .unlin:hover {
      text-decoration: underline;
      cursor: pointer;
      color: $primary-color;
    }
  }
  .guangao {
    width: 200px;
    height: 100%;

    background: red;
    a {
      margin-bottom: 10px;
    }
  }
}
.banner {
  width: 100%;
  height: 450px;
  min-width: $wrap-width;
  position: relative;
  overflow: hidden;
  .bannercont {
    width: 1920px;
    height: 450px;
    position: relative;
    left: 50%;
    top: 0;
    margin-left: -960px;
    .slides li {
    }
    img {
      width: 100%;
    }
    .flex-control-paging {
      width: 100%;
      margin: 0;
      list-style: none;
      position: absolute;
      left: 0;
      bottom: 20px;
      z-index: 3;
      text-align: center;
      font-size: 0;
      li {
        display: inline-block;
        a {
          display: block;
          list-style: none;
          margin: 0 5px;
          width: 30px;
          height: 5px;
          background-color: #000;
          opacity: 0.5;
          filter: alpha(opacity=50);
          &.flex-active {
            opacity: 1;
            filter: alpha(opacity=100);
            background-color: #fff;
          }
        }
      }
    }
  }
  .fbox {
    width: 210px;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: absolute;

    left: 50%;
    margin-left: 600px - 200px;
    z-index: 3;
    .logininfo {
      overflow: hidden;
      padding-top: 15px;
      .touxiang {
        width: 55px;
        height: 55px;
        float: left;
        margin-right: 10px;
        img {
          width: 55px;
          height: 55px;
          border-radius: 50%;
        }
      }
      .name {
        padding-top: 5px;
      }
    }
    .kuaibao {
      margin-top: 20px;
      .hd {
        .tit {
          float: left;
          font-size: 13px;
          font-weight: bold;
        }
        .more {
          font-size: 10px;
          color: #999;
          float: right;
        }
      }
      .bd {
        font-size: 12px;
        color: #666;
        // margin-top: 10px;
        // margin-left: 12px;
        line-height: 20px;
        a {
          display: block;
          @include ellipsis;
          font-size: 12px;
          line-height: 24px;
          color: #000;
          font-weight: 550;
        }
      }
    }
    .gnft {
      text-align: center;
      border-top: 1px solid #eee;
      margin-top: 10px;
      padding-top: 15px;
      li {
        width: 33.33%;
        float: left;
        font-size: 12px;
        color: #806f66;
        .icon {
          font-size: 20px;
        }
        .tit {
          font-size: 12px;
          color: #000;
        }
      }
    }
  }
}

.miaosha {
  height: 275px;
  margin-top: 30px;
  position: relative;
  background-color: #fff;
  .hd {
    width: 200px;
    height: 275px;
    float: left;
    background: url("/static/images/miaosha_bg.png");
    background-size: 100% 100%;
    text-align: center;
    color: #fff;
    .t1 {
      line-height: 1;
      font-size: 34px;
      padding-top: 45px;
    }
    .t2 {
      font-size: 20px;
      opacity: 0.5;
      margin-top: 8px;
    }
    .time {
      // margin-top: 10px;
      font-size: 20px;
      color: #000;
      .item {
        display: inline-block;
        width: 38px;
        height: 38px;
        background: #000;
        line-height: 38px;
        color: #fff;
      }
    }
  }
  .bd {
    width: 1250px;
    box-sizing: border-box;
    float: left;
    position: relative;
    .slides li {
      width: 200px;
      height: 275px;
      float: left;
      .cont {
        padding: 15px;
        display: block;
        border-left: 1px solid #eee;
        height: 100%;
      }
      &:first-child .cont {
        border-left: none;
      }
      .img {
        text-align: center;
        img {
          width: 160px;
          height: 160px;
        }
      }
      .tit {
        margin-top: 15px;
        font-size: 14px;
        color: #666;
      }

      .jiage {
        margin-top: 10px;
        .xianjia {
          color: #f00;
          font-weight: bold;
        }
        .yuanjia {
          color: #999;
          text-decoration: line-through;
          font-size: 12px;
        }
      }
    }
    .flex-direction-nav {
      list-style: none;
      li {
        list-style: none;
        position: absolute;
        top: 117px;
        &.flex-nav-prev {
          left: 0;
        }
        &.flex-nav-next {
          right: 0;
        }
        a {
          color: #fff;
          background-color: #ccc;
          width: 20px;
          height: 40px;
          display: block;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          &:hover {
            background-color: $primary-color;
          }
        }
      }
    }
  }
}
.miaoshadDetail {
  height: 34px;
  width: 100%;
  margin: 20px 0;
  color: #fff;
  background: rgba(241, 157, 21, 1);
  padding: 0 15px;
  box-sizing: border-box;
  .color-black {
    background: #000;
    color: #fff;
    border-radius: 2px;
    padding: 0px 4px;
    margin: 0 5px;
  }
}
.zqtg {
  width: 390px;
  float: left;
  background-color: #fff;
  margin-right: 15px;
  .hd {
    height: 55px;
    line-height: 55px;
    padding: 0 15px;
    .tit {
      font-size: 18px;
      font-weight: bold;
      float: left;
    }
    .en {
      font-size: 14px;
      font-weight: bold;
      float: left;
      margin-left: 10px;
    }
    .more {
      float: right;
      font-size: 14px;
      color: #999;
      background: url(../static/images/arr.png) no-repeat right center;
      padding-right: 20px;
    }
  }
  .bd {
    height: 410px;
    overflow: hidden;
    img {
      width: 100%;
      height: 410px;
    }
    .btnbox {
      .quanitem {
        margin: 0 auto 10px;
      }
    }
  }
}
.quanitem {
  width: 348px;
  height: 120px;
  background: url(../static/images/quanbg.png) no-repeat center;
  color: #fff;
  text-align: center;
  overflow: hidden;
  .cont {
    overflow: hidden;
  }
  .mianzhi {
    font-size: 32px;
    font-weight: bold;
    line-height: 1;
    margin-top: 30px;
  }
  .manjian {
    width: 186px;
    height: 16px;
    background: #fff;
    line-height: 16px;
    font-size: 12px;
    color: #ff2847;
    margin: 10px auto 0;
    letter-spacing: 2px;
  }
  .ft {
    width: 114px;
    float: right;
  }
  .tit {
    margin-top: 20px;
  }
  .layui-btn {
    border: none;
    color: #ff2847;
    font-weight: bold;
    margin-top: 5px;
  }
}
.scfx {
  height: 30px;
  margin-top: 20px;
}
.soucan {
  font-size: 12px;
  color: #999;
  .iconfont {
    margin-right: 5px;
  }
  .icon-share {
    color: $primary-color;
  }
  .selected {
    color: $primary-color;
  }
}
.zyhd {
  margin-top: 50px;
  .ft {
    a {
      margin-left: 30px;
    }
  }
}
.cpgroup {
  margin-top: 25px;
  overflow: hidden;
  .gd {
    width: 222px;
    float: left;
    height: 300px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .bd {
    .imgbox {
      width: 471px;
      height: 300px;
      float: left;
      margin: 0 0 15px 15px;
    }
    .item {
      width: 222px;
      height: 300px;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      float: left;
      list-style: none;
      margin: 0 0 15px 15px;
      text-align: center;
      .img {
        img {
          width: 185px;
          height: 185px;
        }
      }
      .tit {
        margin-top: 10px;
        line-height: 18px;
        width: 185px;
        font-size: 12px;
        white-space: wrap;
        height: 36px;
      }

      .price {
        margin-top: 6px;
        .xianjia {
          color: #f00;
          font-weight: bold;
          font-size: 18px;
        }
        .yuanjia {
          color: #999;
          text-decoration: line-through;
          font-size: 12px;
        }
      }
    }
  }
  #cainixihuanlist {
    .item {
      margin-left: 10px;
      width: 231px;
    }
  }
}
.cphd {
  margin-top: 50px;
  padding-left: 10px;
  line-height: 1;
  border-left: 5px solid #000;
  .cn {
    font-weight: bold;
    font-size: 18px;
  }
  .en {
    text-transform: uppercase;
    margin-left: 10px;
  }
}
.caihd {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-top: 50px;
  margin-bottom: 40px;
  &:before,
  &:after {
    content: "";
    width: 60px;
    height: 1px;
    background-color: #000;
    display: inline-block;
    vertical-align: middle;
  }
  &:before {
    margin-right: 20px;
  }
  &:after {
    margin-left: 20px;
  }
}

.baozhang {
  background-color: #fff;
  padding: 0px 0;
  color: #000;
  li {
    width: 25%;
    float: left;
    img {
      float: left;
      margin-right: 15px;
    }
    .tit {
      font-weight: bold;
      font-size: 18px;
    }
    .desc {
      font-size: 15px;
      color: #999;
    }
  }
  height: 150px;
  background: url("/static/images/footerbg.png");
  background-size: 100% 100%;
}
.footer {
  min-width: $wrap-width;
  margin-top: 60px;
  background-color: #262626;
  color: #ccc;
  .cont {
    padding: 40px 0;
  }
  .lianxi {
    width: 228px;
    text-align: center;
    float: left;
    .telnum {
      font-size: 22px;
      color: #fff;
    }
    .desc {
      font-size: 12px;
      color: #999;
    }
    .lxbtn {
      display: inline-block;
      width: 110px;
      height: 30px;
      border: 1px solid #ccc;
      border-radius: 4px;
      line-height: 28px;
      &:hover {
        border-color: $primary-color;
      }
    }
  }
  .footerlink {
    width: 730px;
    float: left;
    dl {
      width: 25%;
      padding-left: 40px;
      float: left;
      box-sizing: border-box;
      dt {
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: normal;
      }
      dd {
        margin: 0;
        line-height: 24px;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .qrbox {
    text-align: center;
    font-size: 12px;
    a {
      margin-top: 10px;
    }
    img {
      width: 26px;
      height: 26px;
      margin-right: 12px;
    }
  }
  .copy {
    padding: 5px 0;
    text-align: center;
    font-size: 12px;
    color: #666;
    // border-top: 1px solid #333;
    .link {
      a {
        margin: 0 10px;
        //  color: #666;
      }
    }
  }
}

.path {
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  & > .iconfont {
    font-size: 12px;
    color: #999;
    margin: 0 20px;
  }
  .keyword {
    border: 1px solid $primary-color;
    padding: 2px 5px 2px 10px;
    .iconfont {
      color: $primary-color;
    }
  }
}
.son_shouxin {
  background: #f5f5f5;
  .orderlist {
    .el-dialog__body {
      //  margin:10vh 0;
      height: 50vh;
      overflow-y: auto;
    }
  }
  .title {
    font-size: 18px;
    height: 60px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 60px;
    padding-left: 30px;
    background: #fff;
  }
  .son_list {
    margin: 20px 0;
    margin-bottom: 0;
    flex-wrap: wrap;
    .son_item {
      width: 460px;
      height: 156px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      margin-bottom: 20px;
      .sonName {
        height: 56px;
        padding-left: 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #f5f5f5;
      }
      .bold12 {
        font-size: 12px;
        font-weight: bold;
        color: #333333;
      }
      .normal12 {
        font-size: 12px;
        color: #666666;
      }
      .bold18 {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
      .sonData {
        height: 98px;
      }
    }

    .order {
      width: 288px;
      height: 156px;
      margin-right: 42px;
      .sonName {
        padding: 0 30px;
        .mingxi {
          font-size: 12px;
          color: $primary-color;
          border: 1px solid $primary-color;
          padding: 1px 3px;
          cursor: pointer;
        }
      }
    }
    .order:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.collect {
  padding: 30px;
  box-sizing: border-box;
  .title {
    color: $primary-color;
    display: inline-block;
    border-bottom: $primary-color 2px solid;
    margin-bottom: 40px;
  }

  .collectGoods_list {
    flex-wrap: wrap;
    .collectGoods_item {
      width: 222px;
      height: 322px;
      box-sizing: border-box;
      padding: 5px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.05);
      margin-bottom: 20px;
      margin-right: 20px;
      .goodsimg {
        width: 100%;
        height: 210px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .price {
        margin-top: 10px;
        .price_num {
          font-size: 20px;
          color: #cf121e;
        }
        .sale {
          font-size: 12px;
          color: #999;
        }
      }
      .goodsname {
        font-size: 12px;
        color: #333;
        margin: 10px 0;
      }
      .shopname {
        background: $primary-color;
        color: #fff;
        font-size: 12px;
        padding: 2px 5px;
        border-radius: 5px;
      }
    }
  }
}

.product-screen {
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #eee;
  .item {
    border-bottom: 1px solid #eee;
    @include clearfix;
    position: relative;
    &:last-child {
      border-bottom: none;
    }
  }
  .hd {
    width: 120px;
    box-sizing: border-box;
    padding: 0 10px;
    line-height: 40px;
    font-weight: bold;
    background-color: #f8f8f8;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .bd {
    padding: 0 100px 0 150px;
    width: 1250px;
    box-sizing: border-box;
    overflow: hidden;
    ul {
      width: 100%;
      .selectedBrand {
        border: 1px solid $primary-color;
        padding: 3px 15px;
        margin-right: 12px;
        position: relative;
        .icon-cha {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
    .el-radio-group {
      width: 98%;
      height: 40px;
      .el-radio__label {
        line-height: 40px;
      }
    }

    li {
      display: inline-block;
      line-height: 20px;
      margin: 10px;
    }
    a {
      color: #666;
      display: block;
      position: relative;
      &.active {
        color: $primary-color;
      }
    }
    &.open .el-radio-group {
      height: auto;
    }
  }
  .ft {
    width: 100px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    color: #999;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: border-box;
  }
}

.pxbox {
  height: 40px;
  margin-top: 20px;
  font-size: 14px;
  background-color: #f8f8f8;
  padding: 0 10px;
  .paixu {
    float: left;
    margin-top: 6px;
    a {
      float: left;
      height: 28px;
      padding: 0 10px;
      margin-right: -1px;
      line-height: 26px;
      background-color: #fff;
      border: 1px solid #eee;
      position: relative;
      font-size: 12px;
      .arr {
        position: relative;
        width: 8px;
        height: 10px;
        margin-left: 5px;
        font-size: 0;
        display: inline-block;
        vertical-align: middle;
        margin-top: -1px;
        &.down {
          &:before {
            content: "";
            width: 2px;
            height: 5px;
            background-color: #666;
            position: absolute;
            top: 0;
            left: 3px;
          }
          &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            border-top: 5px solid #666;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
          }
        }
        &.up {
          &:before {
            content: "";
            width: 2px;
            height: 5px;
            background-color: #666;
            position: absolute;
            top: 5px;
            left: 3px;
          }
          &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            border-bottom: 5px solid #666;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
          }
        }
      }
      .arr02 {
        position: relative;
        width: 8px;
        height: 10px;
        margin-left: 5px;
        font-size: 0;
        display: inline-block;
        vertical-align: middle;
        margin-top: -1px;
        &:before {
          content: "";
          border-bottom: 4px solid #666;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          position: absolute;
          top: 0;
          left: 0;
        }
        &:after {
          content: "";
          border-top: 4px solid #666;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }

      &.active,
      &:hover {
        color: $primary-color;
        .arr {
          &:before {
            background-color: $primary-color;
          }
          &:after {
            border-top-color: $primary-color;
            border-bottom-color: $primary-color;
          }
        }
        .arr02.up {
          &:before {
            border-bottom-color: $primary-color;
          }
        }
        .arr02.down {
          &:after {
            border-top-color: $primary-color;
          }
        }
      }
    }
  }
  .pricesearch {
    float: left;
    margin-left: 10px;
    margin-top: 6px;
    input {
      width: 80px;
      height: 28px;
      padding: 0 10px;
      box-sizing: border-box;
      background: #fff;
      border: 1px solid #eee;
    }
    .btn {
      width: 30px;
      height: 28px;
      font-size: 14px;
      background: #fff;
      border: 1px solid #eee;
      color: $primary-color;
    }
  }
  .sx {
    height: 28px;
    background-color: #fff;
    border: 1px solid #eee;
    line-height: 26px;
    font-size: 12px;
    float: left;
    padding: 0 10px;
    margin: 6px 0 0 10px;
    .layui-form-checkbox[lay-skin="primary"] {
      span {
        font-size: 12px;
      }
    }
  }
  .fenye {
    float: right;
    font-size: 12px;
    height: 28px;
    margin-top: 6px;
    line-height: 28px;
    .fybtn {
      height: 28px;
      padding: 0 10px;
      box-sizing: border-box;
      float: left;
      display: inline-block;
      margin-left: -1px;
      line-height: 26px;
      background-color: #fff;
      border: 1px solid #eee;
    }
  }
}

.product-list {
  margin-top: 20px;
  li {
    // height: 370px;
    width: 230px;
    margin-bottom: 10px;
    float: left;
    margin-right: 10px;
    padding: 15px;
    background-color: #fff;
    box-sizing: border-box;
    &:hover {
      border: 1px solid #eee;
      padding: 14px;
      box-shadow: 0 0 5px rgba(#000, 0.05);
    }
    .img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 200px;
        height: 200px;
      }
    }
    .tit {
      margin-top: 10px;
      font-size: 12px;
      line-height: 16px;
      height: 32px;
    }
    .jiage {
      margin-top: 10px;
      overflow: hidden;
      font-size: 12px;
      line-height: 20px;
      .xianjia {
        color: $danger-color;
        font-size: 18px;
      }
      .yuanjia {
        color: #666;
        text-decoration: line-through;
      }
      .sold {
        color: #999;
      }
    }
    .shopname {
      margin-top: 5px;
      font-size: 12px;
      color: #999;
    }
    .tags {
      margin-top: 5px;
      .tag01 {
        display: inline-block;
        padding: 0 3px;
        height: 16px;
        margin-right: 4px;
        background-color: $primary-color;
        border-radius: 2px;
        color: #fff;
        line-height: 16px;
        font-size: 12px;
        box-sizing: border-box;
      }
      .tag02 {
        display: inline-block;
        padding: 0 3px;
        height: 16px;
        margin-right: 4px;
        border: 1px solid $primary-color;
        border-radius: 2px;
        color: $primary-color;
        line-height: 14px;
        font-size: 12px;
        box-sizing: border-box;
      }
    }
    .addCar {
      margin-top: 10px;
      .jishuqi {
        width: 100px;
      }
    }
  }
  ul {
    li:nth-child(5n) {
      margin-right: 0;
    }
  }
}

.product-main {
  float: left;
  margin-top: 40px;
}

.product-imgshow {
  width: 420px;
  float: left;
  margin-right: 20px;
  .spec-preview {
    width: 420px;
    height: 420px;
  }

  .jqzoom {
    position: relative;
    cursor: pointer;
    img {
      width: 100%;
      height: 420px;
    }
  }
  .zoomdiv {
    z-index: 100;
    position: absolute;
    top: 0px;
    left: 0px;
    border: 1px solid #ddd;
    background: #fff;
    display: none;
    text-align: center;
    overflow: hidden;
    img {
      max-width: none;
    }
  }

  .jqZoomPup {
    z-index: 10;
    visibility: hidden;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 20px;
    height: 20px;
    border: 1px solid mix(#000, $primary-color, 50%);
    background: $primary-color;
    opacity: 0.5;
    -moz-opacity: 0.5;
    filter: alpha(Opacity=50);
  }

  .spec-scroll {
    height: 60px;
    margin-top: 10px;
    @include clearfix;
    .prev {
      float: left;
    }
    .next {
      float: right;
    }
    .prev,
    .next {
      width: 20px;
      height: 60px;
      line-height: 60px;
      background-color: #eee;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      color: #999;
      &:hover {
        background-color: #ddd;
        color: #333;
      }
    }
    .items {
      width: 380px;
      height: 100%;
      float: left;
      position: relative;
      overflow: hidden;
      ul {
        position: absolute;
        width: 999999px;
        height: 100px;
      }
      li {
        float: left;
        width: 76px;
        height: 60px;
        text-align: center;
        cursor: pointer;
        position: relative;
        img {
          width: 60px;
          height: 60px;
          margin: 0 5px;
        }

        &.active:before {
          content: "";
          border: 2px solid $primary-color;
          position: absolute;
          left: 8px;
          right: 8px;
          top: 0;
          bottom: 0;
        }
      }
    }
  }
}

.product-info {
  overflow: hidden;
  .productname {
    font-size: 20px;
    font-weight: bold;
  }
  .desc {
    font-size: 14px;
    color: $primary-color;
  }
  .jiage {
    background-color: #f8f8f8;
    padding: 15px;
    margin-top: 20px;
    font-size: 12px;
    position: relative;
    .pingjia {
      position: absolute;
      right: 12px;
      top: 12px;
      font-size: 14px;
      text-align: center;
      .yuanjia {
        font-size: 14px;
      }
    }
    .item {
      overflow: hidden;
      line-height: 30px;
    }
    .tit {
      color: #999;
      width: 70px;
      float: left;
      font-size: 16px;
    }
    .cont {
      overflow: hidden;
    }
    .price {
      font-size: 30px;
      font-weight: bold;
      line-height: 1;
    }
    .yuanjia {
      color: #999;
      font-size: 16px;
    }
    .goodsyuanjia {
      text-decoration: line-through;
    }
  }
  .info {
    margin-top: 20px;
    padding: 10px 0;
    overflow: hidden;
    border: 1px dashed #eee;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    color: #999;
    .item {
      width: 33.33%;
      float: left;
      border-right: 1px solid #eee;
      &:last-child {
        border-right: none;
      }
    }
  }
  .canshu {
    padding: 15px;
    .item {
      overflow: hidden;
      padding: 5px 0;
      .tit {
        color: #999;
        width: 70px;
        float: left;
      }
      .cont {
        overflow: hidden;
        li {
          float: left;
          margin: 0 5px 5px 0;
          a {
            display: block;
            line-height: 28px;
            height: 30px;
            border: 1px solid #e8e8e8;
            padding: 0 10px;
            font-size: 12px;
            box-sizing: border-box;
          }
          &.active a {
            color: $primary-color;
            border-color: $primary-color;
          }
        }
      }
    }
  }
  .shuliang {
    padding: 15px;
    margin-top: 20px;
    .tit {
      color: #999;
      width: 70px;
      float: left;
    }
    .numbers {
      float: left;
      margin-right: 8px;
      input {
        width: 50px;
        height: 30px;
        float: left;
        text-align: center;
        border: 1px solid #999;
        box-sizing: border-box;
      }
      .jiajian {
        width: 16px;
        margin-top: -4px;
        float: left;
        margin-left: 3px;
        a {
          display: block;
          margin-top: 4px;
          height: 13px;
          border: 1px solid #999;
          text-align: center;
          line-height: 11px;
          font-size: 12px;
          color: #999;
          box-sizing: border-box;
          &:active {
            background-color: #eee;
          }
        }
      }
    }
  }
  .btnbox {
    padding-left: 85px;
    margin-top: 30px;
    overflow: hidden;
    .layui-btn {
      width: 180px;
    }
  }
}
.product-title {
  height: 40px;
  margin-top: 50px;
  border-bottom: 1px solid $primary-color;
  line-height: 39px;
  h2 {
    height: 100%;
    float: left;
    margin: 0 5px 0 0;
    padding: 0 40px;
    text-align: center;
    cursor: pointer;
    background-color: #eee;
    border-radius: 4px 4px 0 0;
    font-size: 16px;
    line-height: 39px;
    font-weight: normal;
    &.active {
      background-color: $primary-color;
      color: #fff;
    }
  }
}
.product-content {
  .pt-item {
    text-align: center;
    // margin-top: 20px;
    @include clearfix;
    // font-size: 14px;
    // line-height: 1.8;
    img {
      max-width: 100%;
    }
  }
  .goodsdetail {
    text-align: left;
  }
}

.plbox {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  text-align: left;
  .pl-hd {
    width: 120px;
    float: left;
    margin-right: 20px;
    overflow: hidden;
    text-align: center;
    .pl-touxiang {
      width: 60px;
      height: 60px;
      margin: 0 auto;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      margin-top: 5px;
      font-size: 12px;
    }
  }
  .pl-bd {
    overflow: hidden;
  }
  .pl-info {
    margin-top: 8px;
    color: #999;
    font-size: 12px;
  }
  .pl-img {
    .imgtab a {
      width: 54px;
      height: 54px;
      padding: 2px;
      border: 1px solid #ccc;
      cursor: pointer;
      float: left;
      margin: 6px 6px 0 0;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
      &.active {
        border-color: $primary-color;
        position: relative;
        &:before {
          position: absolute;
          left: 50%;
          bottom: -5px;
          margin-left: -5px;
          font-size: 0;
          content: "";
          border-top: 5px solid $primary-color;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
        }
      }
    }
    .bigcpimg {
      margin-top: 10px;
      max-width: 400px;
      max-height: 400px;
      border: 1px solid #ddd;
      position: relative;
      .img {
        max-width: 100%;
        max-height: 100%;
      }
      .close {
        background-color: #eee;
        padding: 0 10px;
        font-size: 12px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .btnprev,
      .btnnext {
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -20px;
        width: 30px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        background-color: #000;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
      }
      .btnnext {
        left: auto;
        right: 0;
      }
    }
  }
}

.sitit {
  text-align: center;
  color: #999;
}
.product-side {
  width: 200px;
  float: left;
  // margin-top: 40px;
  margin-right: 40px;
}
.liulanjilu {
  text-align: center;
  li {
    // padding: 15px;
    margin-bottom: 12px;
    .img {
      img {
        width: 200px;
        height: 200px;
      }
    }
    .name {
      margin-top: 10px;
      font-size: 12px;
      color: #666;
    }
    .price {
      color: #f00;
    }
  }
}

.cartit {
  height: 40px;
  margin-top: 30px;
  line-height: 40px;
  border-bottom: 1px solid #ddd;
  .tit {
    float: left;
    height: 40px;
    border-bottom: 2px solid $primary-color;
    font-size: 16px;
    font-weight: bold;
    color: $primary-color;
  }
}
.cartcontent {
  .theader {
    font-weight: bold;
  }
  .cart-select {
    width: 30px;
  }
  .cart-price {
    width: 150px;
  }
  .cart-numbers {
    width: 150px;
  }
  .cart-checkedboc {
    width: 50px;
  }
  .cart-total {
    width: 188px;
  }
  .cart-ctrl {
    width: 150px;
  }
  .cpinfo {
    .img {
      width: 80px;
      border: 1px solid #eee;
      float: left;
      margin-right: 10px;
      img {
        width: 80px;
        height: 80px;
      }
    }
    .cont {
      overflow: hidden;
      margin-right: 50px;
    }
    .info {
      font-size: 12px;
      color: #999;
      margin-top: 10px;
    }
  }
  .layui-table tbody tr:hover {
    background-color: #fff;
  }
  td {
    padding: 15px;
  }
}

#fenye {
  background: #f5f5f5;
  text-align: center;
  padding: 15px 0;
  margin: 20px 0;
  .active {
    background: $primary-color;
  }
}
// 评价页面
.pinjiatype {
  padding: 10px;
  margin: 20px 0;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
}
// 积分页面
.jifenList {
  flex-wrap: wrap;
  margin: 30px 0;
  .jifenItem:nth-child(4n) {
    margin-right: 0;
  }
  .jifenItem {
    width: 215px;
    display: block;
    margin-right: 12px;
    margin-bottom: 20px;
    .img {
      width: 100%;
    }
    .goodsimg {
      width: 100%;
      height: 222px;
    }
    .goodsInfo {
      padding: 15px 10px;
      box-sizing: border-box;
      width: 100%;
      direction: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-size: 12px;
        color: #333;
      }
      .duihuan {
        font-size: 18px;
        color: rgba(255, 33, 33, 1);
        .yuanjia {
          font-size: 12px;
          color: #999;
          text-decoration: line-through;
        }
        button {
          width: 66px;
          height: 26px;
          font-size: 12px;
        }
      }
    }
  }
}
// 秒杀页面
.seckill {
  .seckill_list {
    .container {
      height: 100%;
    }
    width: 100%;
    height: 60px;
    background: rgba(255, 248, 243, 1);
    li {
      width: 18.75%;
      height: 100%;
      color: #222;
      .title {
        font-weight: bold;
        font-size: 20px;
        margin-right: 15px;
      }
      .shengyu {
        font-size: 14px;
        line-height: 16px;
      }
      .el-button.is-round {
        padding: 8px 16px;
      }
    }
    .active {
      width: 25%;
      background: $primary-color;
      color: #fff;
    }
  }
}

.cartfooter {
  height: 50px;
  line-height: 48px;
  background-color: #fff;
  border: 1px solid #ddd;
  padding-left: 15px;
  box-sizing: border-box;
  .layui-btn {
    height: 48px;
    vertical-align: middle;
    float: right;
    line-height: 48px;
    font-weight: bold;
    font-size: 18px;
  }
}

.jesuanhd {
  font-size: 18px;
  margin-top: 30px;
}
.jiesuanbox {
  margin-top: 10px;
  background-color: #fff;
  padding: 20px;
  font-size: 12px;
  .adr-detail {
    // width: 550px;
  }
  hr {
    margin: 30px 0;
  }
}
.jstit {
  overflow: hidden;
  font-size: 16px;
  .tit {
    font-weight: bold;
  }
}
.adrlist {
  margin-top: 15px;
  overflow-y: auto;
  max-height: 42px * 4;
  .item {
    height: 30px;
    margin: 0 0 12px;
    line-height: 30px;
    overflow: hidden;
    &:hover {
      background-color: #f8f8f8;
      .adr-btns {
        display: block;
      }
    }
    &.active {
      .adr-name {
        border-color: $primary-color;
        position: relative;
        &:before {
          content: "\e67a";
          position: absolute;
          right: -1px;
          bottom: -1px;
          line-height: 1;
          font-size: 14px;
          color: $primary-color;
          font-family: "iconfont" !important;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
      }
    }
    .adr-name {
      width: 146px;
      height: 30px;
      cursor: pointer;
      float: left;
      line-height: 28px;
      text-align: center;
      background-color: #fff;
      border: 1px solid #ddd;
      box-sizing: border-box;
      &:hover {
        border-color: $primary-color;
      }
    }
    .adr-detail {
      float: left;
      span {
        margin-left: 10px;
      }
    }
    .adr-btns {
      float: right;
      margin-left: 20px;
      display: none;
      a {
        color: #005ea7;
        margin-left: 10px;
        &:hover {
          color: #f00;
        }
      }
    }
  }
}
.selectgroup {
  margin-top: 10px;
  li {
    width: 120px;
    height: 30px;
    float: left;
    cursor: pointer;
    margin-right: 10px;
    background-color: #fff;
    border: 1px solid #ddd;
    text-align: center;
    line-height: 28px;
    position: relative;
    box-sizing: border-box;
    &.active {
      border-color: $primary-color;
      &:before {
        content: "\e67a";
        position: absolute;
        right: -1px;
        bottom: -1px;
        line-height: 1;
        font-size: 14px;
        color: $primary-color;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
    img {
      height: 16px;
    }
  }
}

.ordertotal {
  text-align: right;
}

.adrpop {
  padding: 20px;
  select {
    width: 100%;
    -webkit-appearance: menulist;
  }
}
.jieguo {
  .icon {
    margin-top: 30px;
    font-size: 80px;
    line-height: 1;
    text-align: center;
    color: #19a041;
  }
  .jieguo-title {
    text-align: center;
    font-size: 24px;
    margin-top: 15px;
  }
}

.smzf {
  text-align: center;
  margin-top: 30px;
  img {
    width: 200px;
    height: 200px;
  }
  .tit {
    font-size: 18px;
  }
  .iconfont {
    font-size: 24px;
  }
}

.help-menu {
  width: 240px;
  padding: 10px 20px 20px;
  float: left;
  margin-right: 20px;
  margin-top: 20px;
  // background: #fff;
  h2 {
    margin: 15px 0 5px;
    // padding-bottom: 10px;
    // line-height: 30px;
    margin-bottom: 10px;
    // background: #fff;
    font-size: 18px;
    font-weight: normal;
    // border-bottom: 1px solid #ddd;
  }
  p {
    height: 40px;
    margin: 0;
    line-height: 40px;
  }
  a {
    color: #666;
    font-size: 14px;
    display: block;
  }
  a:hover {
    color: $primary-color;
  }
  .active {
    color: $primary-color;
  }
}
.help-main {
  width: 940px;
  float: right;
  margin-top: 20px;
  padding: 20px;
  // background: #fff;
  overflow: hidden;
  .help-tit {
    padding-bottom: 10px;
    line-height: 30px;
    border-bottom: 1px solid #ddd;
    font-size: 18px;
  }
  .help-cont {
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.8;
    @include clearfix;
    img {
      max-width:fit-content ;
    }
  }
}

.page-title {
  margin-top: 30px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}
.page-date {
  text-align: center;
  color: #999;
}
.page-cont {
  margin-top: 20px;
  @include clearfix;
}

.userheader {
  .search {
    float: right;
    margin: 35px 45px 0 0;
    input {
      width: 230px;
    }
  }
  .usernav {
    float: left;
    height: 40px;
    line-height: 40px;
    margin: 35px 0 0 80px;
    & > ul > li {
      float: left;
      margin: 0 20px;
      position: relative;
      .downmenu {
        position: absolute;
        left: 50%;
        top: 100%;
        background-color: #fff;
        width: 100px;
        margin-left: -50px;
        box-shadow: 0 0 10px rgba(#000, 0.1);
        text-align: center;
        padding: 10px 0;
        display: none;
        &:before {
          content: "";
          border-bottom: 5px solid #fff;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          left: 50%;
          margin-left: -5px;
          top: -5px;
        }
        a {
          display: block;
          font-size: 12px;
          line-height: 30px;
        }
      }
      &:hover .downmenu {
        display: block;
      }
    }
  }
}

.user-left {
  width: 170px;
  float: left;
  background-color: #fff;

  .user-menu {
    dl {
      overflow: hidden;
      border-bottom: 1px solid #eee;
      padding: 20px 0;
    }
    dt {
      margin: 0 0 5px;
      padding: 0 20px;
      font-size: 16px;
      font-weight: bold;
    }
    dd {
      margin: 0;
      font-size: 14px;
      line-height: 32px;
    }
    a {
      color: #666;
      display: block;
      padding: 0 20px;
      &:hover,
      &.active {
        color: $primary-color;
      }
    }
  }
}
.tac {
  .is-active {
    color: $primary-color;
  }
}
.el-tabs__active-bar {
  background-color: $primary-color !important;
}
.user-main {
  overflow: hidden;
  padding-left: 20px;
  //   margin-top: 20px;
}
.miaobaoxie {
  margin-right: 12px;
}
.userinfo {
  width: 200px;
  height: 200px;
  float: left;
  background-color: #fff;
  text-align: center;
  //   padding-top: 25px;
  box-sizing: border-box;
  .touxiang {
    margin-top: 25px;
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
  }
  .name {
    font-size: 18px;
    margin-top: 10px;
  }
  .lev {
    margin: auto;
    margin-top: 10px;
    color: #fff;
    height: 20px;
    width: 80px;
    text-align: center;
    background-size: 100% 100%;
    background: url("/static/images/ykhy.png");
    .usertype {
      margin-left: 6px;
    }
  }
}
.user-order {
  background-color: #fff;
  width: 800px;
  height: 200px;
  float: right;
  .hd {
    padding: 20px 20px 15px;
    font-size: 16px;
    font-weight: bold;
  }
  .bd {
    li {
      width: 20%;
      float: left;
      text-align: center;
      a {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto;
        padding-top: 25px;
        box-sizing: border-box;
        &:hover {
          box-shadow: 0 0 20px rgba(#000, 0.1);
        }
      }
      .icon {
        font-size: 40px;
        line-height: 1;
        position: relative;
        .layui-badge {
          position: absolute;
          left: 50%;
          top: 0;
          margin-left: 15px;
          border-radius: 50%;
          background-color: $primary-color;
        }
      }
      .tit {
        margin-top: 10px;
        font-size: 14px;
      }
    }
  }
}
.layui-card-header.layui-card-header-auto {
  padding-top: 15px;
  padding-bottom: 15px;
  height: auto;
  line-height: 1.6;
}
.qianbao {
  width: 200px;
  height: 200px;
  background-color: #fff;
  margin: 20px 00px 0 0;
  float: left;
  .bd {
    margin-top: 20px;
    li {
      width: 50%;
      float: left;
      text-align: center;
      font-size: 12px;
      color: #666;
      .num {
        font-size: 16px;
        font-weight: bold;
      }
      .txt {
        margin-top: 10px;
      }
    }
  }
}
.qhd {
  height: 56px;
  border-bottom: 1px solid #eee;
  line-height: 56px;
  padding: 0 20px;
  .tit {
    font-size: 16px;
    font-weight: bold;
    float: left;
  }
  .more {
    float: right;
    font-size: 12px;
    color: #999;
  }
}
.flex-direction-nav {
  list-style: none;
  li {
    list-style: none;
    position: absolute;
    top: 117px;
    &.flex-nav-prev {
      left: 0;
    }
    &.flex-nav-next {
      right: 0;
    }
    a {
      color: #fff;
      background-color: #ccc;
      width: 20px;
      height: 40px;
      display: block;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      &:hover {
        background-color: $primary-color;
      }
    }
  }
}
.flooorGoods {
  overflow: hidden;
  	position: relative;
  .clearlist {
    .item{
      // margin-left: 0 !important;
      width: 237px !important;
    }
  }
}
.liulan {
  width: 400px;
  height: 200px;
  background-color: #fff;
  margin: 20px 0 0;
  float: left;
  .bd {
    padding: 20px 10px 0;
    box-sizing: border-box;
    .center {
      justify-content: flex-start;
    }
    li {
      width: 33.3%;
      text-align: center;
      a {
        width: 100%;
        text-align: center;
      }
      li:last-of-type {
        margin-right: 0;
      }
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}

.suiji {
  margin-top: 20px;
  .hd {
    height: 40px;
    background-color: #ffe6e8;
    padding: 0 20px;
    color: #cf121e;
    line-height: 40px;
    .btn {
      display: inline-block;
      height: 18px;
      line-height: 18px;
      border: 1px solid #cf121e;
      font-size: 12px;
      padding: 0 5px;
    }
  }
  .bd {
    background-color: #fff;
    padding: 6px;
    .product-list {
      margin-top: 0;
      li {
        width: 20%;
        height: auto;
        padding: 6px 6px 20px;
        &:hover {
          border: none;
          padding: 6px 6px 20px;
          box-shadow: none;
        }
        .img {
          width: 186px;
          height: 186px;
          img {
            width: 186px;
            height: 186px;
          }
        }
      }
    }
  }
}
.shouzhi {
  cursor: pointer;
}
.user-cont {
  .cartcontent {
    .theader {
      font-weight: normal;
    }
    .cart-select {
      width: 30px;
    }
    .cart-price {
      width: 100px;
    }
    .cart-numbers {
      width: 100px;
    }
    .cart-total {
      width: 100px;
    }
    .cart-state {
      width: 100px;
    }
    .cart-ctrl {
      width: 100px;
      text-align: center;
    }
    .cpinfo {
      .cont {
        margin-right: 30px;
      }
    }
    .layui-table tbody tr:hover {
      background-color: #fff;
    }
    td,
    th {
      padding: 10px;
      font-size: 12px;
    }
  }
}
.utab {
  // height: 30px;
  line-height: 60px;
  font-weight: bold;
  padding: 10px;
  li {
    height: 30px;
    box-sizing: border-box;
    float: left;
    margin-right: 30px;
    font-size: 14px;
    border-bottom: 2px solid #fff;
  }
  .active {
    color: $primary-color;
    border-bottom: 2px solid $primary-color;
    font-weight: bold;
    // font-size: 16px;
  }
}

.uploads {
  overflow: hidden;
  padding-top: 10px;
  .item {
    width: 80px;
    height: 80px;
    float: left;
    margin: 0 10px 10px 0;
    background: #f3f3f3 no-repeat center;
    background-size: cover;
    text-align: center;
    font-size: 13px;
    color: #bbb;
    position: relative;
    .icon {
      font-size: 32px;
      line-height: 80px;
      cursor: pointer;
    }
    .delbtn {
      width: 16px;
      height: 16px;
      background-color: #f00;
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      text-align: center;
    }
  }
}
.usearch {
  input {
    width: 170px;
    float: left;
    height: 30px;
    box-sizing: border-box;
    font-size: 12px;
    border-radius: 0;
    margin-right: -1px;
  }
  button {
    float: left;
    border-radius: 0;
  }
}

.logincontent {
  height: 600px;
  background: url(../static/images/loginbg.jpg) no-repeat center;
}
.loginbox {
  float: right;
  width: 350px;
  height: 370px;
  padding: 25px;
  box-sizing: border-box;
  background-color: #fff;
  margin-top: 115px;
  .hd {
    font-weight: bold;
    font-size: 18px;
  }
  .row {
    height: 40px;
    border: 1px solid #ddd;
    margin-top: 20px;
    .icon {
      width: 40px;
      float: left;
      text-align: center;
      line-height: 38px;
      background-color: #eee;
      img {
        vertical-align: middle;
        display: inline-block;
      }
    }
    .cont {
      overflow: hidden;
    }
    input {
      width: 100%;
      height: 38px;
      border: none;
      padding: 0 15px;
      box-sizing: border-box;
    }
  }
}
.loginfooter {
  padding: 25px 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  .link {
    a {
      margin: 0 10px;
    }
  }
}
.regbox {
  background-color: #fff;
  width: 1000px;
  margin: 30px auto 0;
  padding: 50px 30px;
  position: relative;
  .hd {
    font-size: 30px;
    font-weight: bold;
    justify-content: center;
    // align-items: flex-start;
    // align-items: flex-end;
    li {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      margin-right: 40px;
      line-height: 14px;
      height: 32px;
      box-sizing: border-box;
      cursor: pointer;
      // padding-bottom: 5px;
      border-bottom: 2px solid #fff;
    }
    li:nth-child(3n) {
      margin-right: 0;
    }
    .active {
      // font-size:20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 14px;
      color: rgba(241, 157, 21, 1);
      font-weight: bold;
      border-bottom: 2px solid $primary-color;
    }
  }
  .bd {
    width: 320px;
    margin: 0 auto;
  }
  .row {
    margin-top: 20px;
  }
  .layui-form-checked {
    .layui-icon-ok {
      background: $primary-color;
      border: 1px solid $primary-color !important;
    }
  }
  .layui-icon-ok:hover {
    border: 1px solid $primary-color !important;
  }
  .regbtn {
    background: $btn-primary !important;
  }
  .upload {
    height: 130px;
    width: 100%;
    border: 1px solid rgba(229, 229, 229, 1);
  }
}

.adritem {
  margin-top: 15px;
  border: 1px solid #ddd;
  padding: 15px;
  font-size: 12px;
  position: relative;
  .ctrlbox {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #005ea7;
    a {
      color: #005ea7;
      margin-left: 15px;
    }
  }
  .row {
    padding: 5px 0;
    .tit {
      display: inline-block;
      width: 60px;
      color: #999;
      text-align: right;
    }
  }
}
.el-tabs__item.is-active {
  color: $primary-color;
}
.el-tabs__item:hover {
  color: $primary-color;
}
.kblist li {
  border-bottom: 1px solid #ddd;
  padding: 15px 0;
}
.kblist li .tit {
  font-weight: bold;
}
.kblist li .desc {
  margin-top: 10px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-box;
  display: box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  box-orient: vertical;
  -webkit-line-clamp: 3;
}
.llwgoodsimg_name {
  width: 128px;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 120px;
  }
  .name {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
}
.remaituijian {
  width: 25%;
  display: inline-block;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
}
.remai {
  width: 592px;
}
.pindao {
  width: 290px;
  justify-content: stretch !important;
  .llwgoodsimg_name {
    margin-left: 10px;
    margin-right: 5px;
  }
}
.goodslistDesc {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .desc {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-left: 10px;
  }
}
.goodslist {
  background: #fff;
  flex-wrap: wrap;
  justify-content: space-around;
}
.rexiao {
  .llwgoodsimg_name {
    width: 270px;
    height: 125px;
    background: rgba(255, 251, 245, 1);
    img {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }
    .name {
      width: 140px;
    }
    .name_soucan {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 10px;
    }
  }
}
// 待结算订单
.awaitorder {
  padding: 12px;
  .color-primary {
    .is-checked {
      .el-checkbox__inner {
        background: #f19d15 !important;
        border-color: #f19d15;
      }
    }
    .el-checkbox__inner {
      border-color: #f19d15 !important;
    }
  }
  .totalnum {
    // width: 100%;
    height: 70px;
    background: rgba(245, 245, 245, 1);
    padding: 0 30px;
    box-sizing: border-box;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    margin-top: 20px;
    margin-right: 20px;
    .submit {
      button {
        // height: 40px;
        // width: 110px;
        // border-radius: 20px;
        font-size: 14px;
      }
    }
  }
  .upload {
    .uploadbtn {
      button {
        width: 100px;
        font-size: 12px;
        height: 30px;
      }
    }
    .icon-refresh {
      font-size: 12px;
      margin-right: 12px;
    }
  }
  .tableheadone {
    height: 40px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    padding: 0 10px;
    .time {
      margin-left: 5px;
      margin-right: 40px;
    }
  }
  .alltitle {
    margin-bottom: 15px !important;
    margin-top: 30px;
  }
  .tabs {
    li {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-right: 30px;
    }
    .active {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #f19d15 !important;
    }
  }
  .pinzheng {
    padding-top: 12px;
    display: flex;

    position: relative;
    //  justify-content: space-around;
    // align-items: flex-end;
    .pinzhengimg {
      width: 300px;
      height: 300px;
      background: rgba(245, 245, 245, 1);
      margin-right: 30px;
      margin-bottom: 20px;
    }
    .addvace {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .layui-card {
    box-shadow: none;
  }
  .layui-btn-sm {
    margin-left: 0;
  }
  .img {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
    a {
      display: inline-block;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .goodsInfo {
    .cont {
      width: 150px;
      margin: 0 10px;
    }
  }

  .cart-price {
    width: 100px;
  }
}
.pdList {
  .goodslist {
    width: 25%;
    height: 400px;
    align-items: flex-start;
    margin-right: 10px;
    .llwgoodsimg_name {
      width: 50%;
      padding: 10px;
      box-sizing: border-box;
      margin-bottom: 10px;
      display: inline-block;
    }
  }
}
.params {
  margin: 4px 0;
  .paramsItem {
    width: 33.3%;
    padding: 8px;box-sizing: border-box;
    display: inline-block;
    text-align: left;
    // margin-bottom: 12px;
  }
  .shipei{
    width: 66%;
  }
}
//首页动画

.social-share {
  width: 200px;
  margin-left: 10px;
}
// element ui
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: $primary-color;
  border-color: $primary-color;
}

.el-radio__input.is-checked + .el-radio__label {
  color: $primary-color !important;
}
.el-select-dropdown__item.selected {
  color: $primary-color !important;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: $primary-color !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: $primary-color !important;
}
.el-button--primary {
  background: $primary-color;
  border-color: $primary-color;
}
.el-button + .el-button {
  margin-left: 0 !important;
  // margin-bottom: 10px !important;;
}
.el-button--primary {
  background: $primary-color !important;
  border-color: $primary-color !important;
}
.plbox .pl-img .bigcpimg {
  display: none;
}
.el-menu-item.is-active {
  color: $primary-color !important;
}
.zhuanzhangpopover {
  // min-width: 600px;
}
.goodslistPage {
  .el-radio {
    margin-right: 20px !important;
    .el-radio__input {
      display: none !important;
    }
  }
  .is-checked {
    .el-radio__label {
      color: $primary-color;
    }
  }
}
.el-tree-node {
  margin-bottom: 10px;
}

.container {
  #address {
    display: none;
  }
  #applocation {
    background: #f2f2f2;
    height: 30px;
    box-sizing: border-box;
    .el-cascader {
      display: flex;
      align-items: center;
      height: 100%;
      .el-input {
        height: 100%;
        line-height: 30px;
        input {
          border: none;
          background: #f2f2f2;
          padding-right: 0;
          height: 100%;
          color: #999;
          font-size: 12px;
          padding-left: 5px;
        }
        span {
          display: none;
        }
      }
    }
  }
}
.el-message-box__btns {
  .el-button--primary {
    margin-left: 10px !important;
  }
}
.fs16{font-size: 16px}
.storeInfo{
  border-bottom: 2px dashed red;
  padding-bottom: 10px;margin-bottom: 30px;
}
.pingjiabyn {
  padding: 3px 15px;
  a {
    color: #fff;
  }
  a:hover {
    color: #fff;
  }
}
.stepActive {
  padding: 24px 0;
}
.applyReturn {
  align-items: flex-start !important;
  min-height: 87vh;
  padding-top: 0 !important;
  border: 1px solid #f0f0f0;
  .orderinfo {
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
    .tit {
      font-size: 16px;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
    }
    .tablegoodsinfo {
      margin-top: 10px;
      border-bottom: 1px solid #f0f0f0;
      padding-bottom: 30px !important;
    }
    .desc {
      color: #666;
      margin-right: 4px;
    }
    .goods_info {
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
    }
  }
  .demo-ruleForm {
    flex: 3;
    padding: 24px 0;
    border-right: 1px solid #f0f0f0;
  
  }
  .returnIng {
    min-height: calc(100vh - 130px);
    box-sizing: border-box;
    .tit {
     
      font-size: 20px;
      color: #000;
      margin: 10px;
    }
    .desc {
      font-size: 16px;
      color: #666;
      margin: 10px;
    }
    .chexiao{
      padding-bottom: 15px;
    }
    .relust{
        margin: 10px 30px;
    }
    
    .status{
      padding-bottom: 15px;
    }
    .border-b{
     
      border-bottom: 1px solid #f5f5f5;
    }
  }
  
}
.resultApply{
       margin:30px 10px ;
       width:250px;height: 40px;
       font-size: 16px;border-radius: 5px;
    }
.el-input-number--mini {
  width: 100px;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: $primary-color;
  background: $primary-color;
}
.el-switch__label.is-active {
  color: $primary-color;
}
#reg .layui-unselect {
  display: none;
}
.el-switch.is-checked .el-switch__core {
  border-color: $primary-color;
  background: $primary-color;
}
.invoiceDialog .el-dialog__body {
  padding: 0;
  margin-top: 30px;
  .jiesuanbox {
    padding: 0;
  }
}
.slides {
  .el-carousel__button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 12px;
  }
  .is-active {
    .el-carousel__button {
      background: $primary-color;
    }
  }
}

.hebin {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
}
.tablegoodsinfo {
  padding: 10px 0px !important;
  .cell {
    padding-left: 0;
    padding-right: 0;
    .hebin:last-child {
      border: none;
    }
  }
}
.layui-layer-shade {
  z-index: 99 !important;
}

// 富文本开始
#preview table.noBorderTable td,
#preview table.noBorderTable th,
#preview table.noBorderTable caption {
  border: 1px dashed #ddd !important;
}
#preview table.sortEnabled tr.firstRow th,
#preview table.sortEnabled tr.firstRow td {
  padding-right: 20px;
  background-repeat: no-repeat;
  background-position: center right;
}
#preview table.sortEnabled tr.firstRow th:hover,
#preview table.sortEnabled tr.firstRow td:hover {
  background-color: #eee;
}
#preview table {
  margin-bottom: 10px;
  border-collapse: collapse;
  display: table;
}
#preview td,
#preview th {
  background: white;
  padding: 5px 10px;
  border: 1px solid #ddd;
}
#preview caption {
  border: 1px dashed #ddd;
  border-bottom: 0;
  padding: 3px;
  text-align: center;
}
#preview th {
  border-top: 1px solid #bbb;
  background: #f7f7f7;
}
#preview table tr.firstRow th {
  border-top: 2px solid #bbb;
  background: #f7f7f7;
}
#preview tr.ue-table-interlace-color-single td {
  background: #fcfcfc;
}
#preview tr.ue-table-interlace-color-double td {
  background: #f7faff;
}
#preview td p {
  margin: 0;
  padding: 0;
}
#preview table.noBorderTable td,
#preview table.noBorderTable th,
#preview table.noBorderTable caption {
  border: 1px dashed #ddd !important;
}
#preview table.sortEnabled tr.firstRow th,
#preview table.sortEnabled tr.firstRow td {
  padding-right: 20px;
  background-repeat: no-repeat;
  background-position: center right;
}
#preview table.sortEnabled tr.firstRow th:hover,
#preview table.sortEnabled tr.firstRow td:hover {
  background-color: #eee;
}
#preview table {
  margin-bottom: 10px;
  border-collapse: collapse;
  display: table;
}
#preview td,
#preview th {
  background: white;
  padding: 5px 10px;
  border: 1px solid #ddd;
}
#preview caption {
  border: 1px dashed #ddd;
  border-bottom: 0;
  padding: 3px;
  text-align: center;
}
#preview th {
  border-top: 1px solid #bbb;
  background: #f7f7f7;
}
#preview table tr.firstRow th {
  border-top: 2px solid #bbb;
  background: #f7f7f7;
}
#preview tr.ue-table-interlace-color-single td {
  background: #fcfcfc;
}
#preview tr.ue-table-interlace-color-double td {
  background: #f7faff;
}
#preview td p {
  margin: 0;
  padding: 0;
}
// 富文本结束

.teletephone{
  font-size:20px;color: #f5091f !important;
  font-weight:550;
}
.mallcart{
  margin-left: 12px;
  font-size:16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue